var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTotalevents(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 35,
    viewBox: "0 0 32 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5472 10.3257V26.7018C28.5472 29.3532 26.5197 31.3807 23.8683 31.3807H6.5564C6.5564 33.0963 7.96006 34.4999 9.67566 34.4999H25.4279C28.8591 34.4999 31.6664 31.6926 31.6664 28.2614V13.4449C31.6664 11.7293 30.2628 10.3257 28.5472 10.3257Z",
    fill: "#424242"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.15301 0.5V3.61926H3.59338C1.87779 3.61926 0.474121 5.02293 0.474121 6.73852V25.4541C0.474121 27.1697 1.87779 28.5733 3.59338 28.5733H22.6209C24.3365 28.5733 25.7401 27.1697 25.7401 25.4541V6.73852C25.7401 5.02293 24.3365 3.61926 22.6209 3.61926H21.0612V0.5H17.942V3.61926H8.27227V0.5H5.15301ZM3.59338 11.4174H22.6209V25.4541H3.59338V11.4174Z",
    fill: "#424242"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7217 24.2061L14.9786 22.0226L11.3914 24.2061L12.3272 19.9951L9.052 17.1878L13.419 16.8758L15.1346 12.8208L16.8501 16.7199L21.2171 17.1878L17.9419 19.9951L18.7217 24.2061Z",
    fill: "#424242"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalevents);
export default __webpack_public_path__ + "static/media/totalevents.c1f699931782b35b706eb2f6c53419b1.svg";
export { ForwardRef as ReactComponent };